import { $ } from "./imports";

const searchModal = () => {

    const $lupaMenu = $(".icon-search-menu");

    $lupaMenu.on('click', function (event) {
        event.preventDefault();
        // Si estamos en la pagina de buscar
        if( $('body').hasClass('path-buscar') ){
            // Hacemos focus en input buscador
            $('.filterbar-search form input[name="combine"]').trigger('focus');
        }else{
            // Muestra el modal utilizando Bootstrap
            // Modal bootstrap
            let modalBsSearch = bootstrap.Modal.getOrCreateInstance(document.querySelector('#block-viewsexposedfilterblock .modal'));

            // Mostramos modal
            modalBsSearch.show();
        }
    });

}

export default searchModal;